<abp-page [title]="'ZenBoss::Notifications' | abpLocalization">
    
</abp-page>